module.exports = __webpack_public_path__ + "static/cover-5510dd8036d205b4912ad560f499e72b.mp4";